import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useGet, usePost } from "seed/api";
import { useDetail } from "seed/gql";
import { Loading } from "seed/helpers";
import { useAuth } from "components/util/helpers/providers/AuthProvider";
import l from "components/util/l";
import View from "components/presentation/sections/permissions/Permissions.view";

function Permissions({
  flow,
  isAdmin,
  refreshFlow
}) {

  const user = useAuth();
  const [isRolesModalOpen, setIsRolesModalOpen] = useState(false);

  const reqPermissions = useGet(`/flows/get_flow_permissions`, { flow_id: flow.id });

  const reqViews = useDetail(`{
    flow {
      flowViews {
        id
        name
        isPrebuilt
        settings
      }
    }
  }`, flow.id);

  const [callSet, reqSet] = usePost("/flows/save_flow_permissions", {
    onCompleted: () => {
      swal(l("Guardado%PA084"), l("Cambios guardados%PA085"), "success");
    },
    onError: () => {
      swal("Error", l("Ocurrió un error inesperado%PA087"), "error");
    },
  });

  useEffect(() => {
    reqPermissions.refetch();
  }, []);

  const onSubmit = (values) =>
    callSet({
      flow_id: flow.id,
      permissions: values
    });

  const onOpenRolesModal = () =>
    setIsRolesModalOpen(true);

  // A role created or deleted in the modal changes the grid's columns and their stored switches.
  const onCloseRolesModal = () => {
    setIsRolesModalOpen(false);
    reqPermissions.refetch();
  };

  const isLoading = reqPermissions.loading || reqViews.loading;
  const isUpdating = reqSet.loading;

  if (isLoading)
    return <div className="w-100 h-75"><Loading /></div>

  const { general = {}, details = {}, collections = [], nodes: unsortedNodes = [] } = reqPermissions.data || {};
  const nodes = [...unsortedNodes].sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  const views = (reqViews.data?.flow?.flowViews || []).map((view) => ({
    ...(view.settings || {}),
    id: view.id,
    name: view.name,
    is_prebuilt: view.isPrebuilt,
  }));

  return <View
    flow={flow}
    user={user}
    isAdmin={isAdmin}
    isUpdating={isUpdating}
    isRolesModalOpen={isRolesModalOpen}
    views={views}
    general={general}
    details={details}
    collections={collections}
    nodes={nodes}
    refreshFlow={refreshFlow}
    onSubmit={onSubmit}
    onOpenRolesModal={onOpenRolesModal}
    onCloseRolesModal={onCloseRolesModal}
  />;

}

export default Permissions;
